<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Cadastrar Usuário") }}</h1>

    <b-card class="shadow">
      <template v-slot:default>
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <form @submit.prevent="submit" ref="addItem">
          <div class="row">
            <form-input
              v-model="item.nome_completo"
              grid="4"
              label="Nome Completo"
              :required="true"
              ajuda="Não será permitido acentos ou caracteres especiais neste campo."
            />
            <form-input
              v-model="item.nome_social"
              grid="4"
              label="Nome Social"
            />
            <form-input
              v-model="item.data_nascimento"
              v-mask="'##/##/####'"
              grid="4"
              label="Data de Nascimento"
              :required="true"
            />
          </div>
          <div class="row">
            <form-input
              v-model="item.nome_curador"
              grid="4"
              label="Nome do Curador/Tutor"
            />
            <form-select
              v-model="item.sexo"
              grid="4"
              label="Sexo"
              :itens="$root.arrays.sexo"
              :required="true"
            />

            <form-select
              v-model="item.genero"
              grid="4"
              label="Gênero"
              :itens="$root.arrays.genero"
            />
          </div>
          <div class="row">
            <form-select
              v-model="item.posicao_familiar"
              grid="6"
              label="Posição familiar"
              :itens="$root.arrays.posicao_familiar"
              :required="true"
            />
            <form-select
              v-model="item.cor_raca"
              grid="6"
              label="Cor ou Raça"
              :itens="$root.arrays.cor_raca"
            />
          </div>
          <div class="row">
            <form-select
              v-model="item.estado_civil"
              grid="4"
              label="Estado Civil"
              :itens="$root.arrays.estado_civil"
            />
            <form-input v-model="item.mae" grid="4" label="Filiação 1" />
            <form-input v-model="item.pai" grid="4" label="Filiação 2" />
          </div>
          <div class="row">
            <form-input v-model="item.telefone" grid="4" label="Telefone" />
            <form-input
              v-model="item.celular"
              grid="4"
              label="Celular/Whatsapp"
            />
            <form-input v-model="item.email" grid="4" label="E-mail" />
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <!-- <label class="font-weight-bold"> </label> -->
              <form-checkbox
                v-model="item.providenciar_documentacao"
                label="Necessidade de providenciar documentação civil"
                :itens="{
                  1: 'Certidão de Nascimento',
                  2: 'Carteira de Trabalho e Previdência Social',
                  3: 'Título de Eleitor',
                  4: 'Carteira de Identidade',
                  5: 'Cadastro de Pessoa Física',
                }"
              />
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="row">
                <form-input
                  v-model="item.nis"
                  grid="8"
                  label="NIS"
                  :required="true"
                  :readonly="item.nao_sabe_nis == 1 ? true : false"
                />
                <form-toggle
                  mt="3"
                  grid="4"
                  v-model="item.nao_sabe_nis"
                  label="Não sabe"
                />
              </div>
              <div class="row">
                <form-input
                  v-model="item.documento.cpf"
                  grid="8"
                  label="CPF"
                  :required="true"
                  :readonly="item.nao_sabe_cpf == 1 ? true : false"
                  :minlength="14"
                  :maxlength="14"
                  v-mask="'###.###.###-##'"
                />
                <form-toggle
                  mt="3"
                  grid="4"
                  v-model="item.nao_sabe_cpf"
                  label="Não sabe"
                />
              </div>
            </div>
          </div>

          <div class="float-right mt-3">
            <router-link class="btn btn-danger" to="/dashboard/usuarios">
              <i class="mdi mdi-close" />
              {{ $t("Cancelar") }}
            </router-link>
            <button
              class="btn btn-success btn-submit"
              data-style="zoom-in"
              type="submit"
            >
              <i class="mdi mdi-content-save" />
              {{ $t("Salvar") }}
            </button>
          </div>
        </form>
      </template>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Add",
  data() {
    return {
      loading: false,
      item: {
        documento: {
          cpf: "",
        }
      },
      providenciar_documentacao: [],
      posicao_familiar: {
        1: "Responsável Familiar - RF",
        2: "Cônjuge ou companheiro(a)",
        3: "Filho(a)",
        4: "Enteado(a)",
        5: "Neto(a) ou bisneto(a)",
        6: "Pai ou mãe",
        7: "Sogro(a)",
        8: "Irmão ou irmã",
        9: "Genro ou nora",
        10: "Outro parente",
        11: "Não parente",
      },
      cor_raca: {
        1: "Branca",
        2: "Preta",
        3: "Amarela",
        4: "Parda",
        5: "Indígena",
      },
      estado_civil: {
        1: "Solteiro(a)",
        2: "Casado(a)",
        3: "Separado(a)",
        4: "Divorciado(a)",
        5: "Viúvo(a)",
        6: "União Estável",
      },
    };
  },
  watch: {
    "item.nome_completo": function (val) {
      //console.log(val);
      val = val.normalize("NFD").replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "");
    },
  },
  methods: {
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      // Send request
      axios.post("api/dashboard/usuarios", this.item).then((response) => {
        ladda.stop();
        this.$snack.success({
          button: false,
          text: response.data.data.message,
        });
        this.$router.push("/dashboard/usuarios");
      });
    },
  },
};
</script>
